import { useMutation, useQuery } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';
import { toastFlashMessage } from 'utils';

// Gets List Passing Criteria for configuration
export const useListPassingCriteriaQuery = () => {
  return useQuery({
    enabled: !Organization?.isRep(),
    queryKey: ['PASSING_CRITERIA'],
    queryFn: async () => {
      const url = 'v2/organization/passing-criteria/list/';
      const data = await API.get(url);
      return data?.data;
    },
  });
};

// Sets a new qualifying criteria, for configuration
export const useUpdatePassingCriteriaMutation = () => {
  return useMutation({
    mutationFn: async ({ criterion_uuid, min_value }) => {
      const url = `/v2/organization/passing-criteria/${criterion_uuid}/update/`;
      const data = await API.put(url, { min_value });
      return data;
    },
    onSuccess: (res) => toastFlashMessage(res?.message, 'success'),
  });
};
